// extracted by mini-css-extract-plugin
module.exports = {"comingWrapper":"ComingSoon_comingWrapper__ZC4Tb"};